<template>
  <v-dialog v-model="dialog" persistent width="30%">
    <v-card>
      <v-card-text class="pt-4">
        <v-layout row>
          <v-flex xs3>
            <v-icon x-large class="error--text darken-1">info</v-icon>
          </v-flex>
          <v-flex xs9 >
            <template v-if="type === 'unsolve'">
              ¿Esta seguro de que desea marcar este chat como no resuelto?
            </template>
            <template v-else>
              <span v-if="type === 'wrongPerson'">¿Esta seguro de que desea marcar este chat como equivocado?</span>
              <span v-else>¿Esta seguro de que desea eliminar este chat?</span>
            </template>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click.native="dialog = false">Cancelar</v-btn>
        <v-btn
          @click="save()"
          class="k-orange-linear-text"
          flat>
          <template v-if="type === 'wrongPerson' || type === 'unsolve'">
            Aceptar
          </template>
          <template v-else>
            Eliminar
          </template>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EventBus from '@/event-bus';

export default {
  created() {
    EventBus.$on('openConfirmDialog', (id, type) => {
      this.type = type;
      this.chatCenterId = id;
      this.dialog = true;
    });
  },
  destroyed() {
    EventBus.$off('openConfirmDialog');
  },
  data() {
    return {
      dialog: false,
      type: '',
      chatCenterId: 0,
      cancelToken: this.axios.CancelToken.source(),
    };
  },
  methods: {
    save() {
      if (this.type === 'wrongPerson') {
        this.axios.patch(`chats_center/${this.chatCenterId}`, {
          chat_center_status_id: 7,
          isWrong: true,
        }).then(() => {
          this.dialog = false;
        }).catch((error) => {
          if (error.response.status === 422) {
            EventBus.$emit('modal', 'Este chat ya fue marcado como equivocado');
          }
        });
      } else if (this.type === 'unsolve') {
        this.axios.patch(`chats_center/${this.chatCenterId}`, {
          chat_center_status_id: 5,
        }).then(() => {
          this.dialog = false;
          this.$emit('statusChanged', {
            id: this.chatCenterId,
            chat_center_status_id: 5,
          });
        }).catch(() => {});
      } else {
        this.axios.delete(`chats_center/${this.chatCenterId}`).then(() => {
          this.dialog = false;
        }).catch((error) => {
          if (error.response.status === 404) {
            EventBus.$emit('modal', 'Este chat ya fue eliminado');
          }
        });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/chat_center/ConfirmDialog.vue